import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {MainScene as Scene} from './Template/MainScene';
import {Store} from '@learningblocks/protocol-redux';
import './App.scss';
import '@learningblocks/protocol-constants/lib/Styles/_styles.scss';
import {
  getAllDataFromAirtable,
  getGlossaryListWithAirtable,
  getIndividualGlossaryItem,
  getIndividialDataFromAirtable,
} from '@learningblocks/exp-constants/lib/Utilities';
import {GlossaryProvider} from '@learningblocks/storybook-components';
import {CATEGORY_LIST, API_DETAILS} from './Constants';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      glossaryData: [],
    };
  }

  componentDidMount() {
      // User snap testing script
      // ------------------------
      // window.onUsersnapCXLoad = function(api) {
      //   api.init();
      // }
      // var script = document.createElement('script');
      // script.defer = 1;
      // script.src = 'https://widget.usersnap.com/global/load/f59ef332-284b-4d3e-90c5-869093982d1f?onload=onUsersnapCXLoad';
      // document.getElementsByTagName('head')[0].appendChild(script);
  }

  /**
   * Get the entire glossary list for glossary
   */
  getFullGlossaryList = () => {
    return getGlossaryListWithAirtable(
      getAllDataFromAirtable,
      API_DETAILS.URL,
      API_DETAILS.KEY,
      'rece7cYqX5H5ZKEoP'
    );
  };

  /**
   * Get individual glossary item
   */
  getIndividualGlossaryItem = () =>
    getIndividualGlossaryItem(
      getIndividialDataFromAirtable,
      API_DETAILS.URL,
      API_DETAILS.KEY
    );

  render() {
    return (
      <div className='page-content wrapper'>
        <GlossaryProvider.Component
          categories={CATEGORY_LIST}
          fetchGlossaryList={this.getFullGlossaryList()}
          fetchGlossaryItem={this.getIndividualGlossaryItem()}>
            <Scene fetchGlossaryItem={this.getIndividualGlossaryItem()} />
        </GlossaryProvider.Component>
      </div>
    );
  }
}

export default Store.getState();

ReactDOM.render(
  <Provider store={Store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
